import { makeGlossaryCtx, linkifyNodes } from "@/lib/glossaryLink";

export default function MarkdownLite({ text, className = "", glossary = null }) {
  const lines = (text || "").split("\n");
  const ctx = makeGlossaryCtx(glossary);
  const used = new Set();
  const blocks = [];
  let list = [];
  const flush = (i) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${i}`} className="list-disc pl-6 space-y-1.5 my-4 text-plum-ink/90">
          {list.map((li, j) => <li key={j}>{inline(li)}</li>)}
        </ul>
      );
      list = [];
    }
  };
  const inline = (s) => {
    const parts = s.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((p, k) =>
      p.startsWith("**") && p.endsWith("**")
        ? <strong key={k} className="font-semibold text-plum">{p.slice(2, -2)}</strong>
        : <span key={k}>{linkifyNodes(p, ctx, used)}</span>
    );
  };
  lines.forEach((raw, i) => {
    const line = raw.trimEnd();
    if (line.startsWith("## ")) { flush(i); blocks.push(<h2 key={i} className="font-display text-2xl sm:text-3xl text-plum mt-10 mb-3">{line.slice(3)}</h2>); }
    else if (line.startsWith("### ")) { flush(i); blocks.push(<h3 key={i} className="font-display text-xl text-plum mt-6 mb-2">{line.slice(4)}</h3>); }
    else if (line.startsWith("- ")) { list.push(line.slice(2)); }
    else if (line.trim() === "") { flush(i); }
    else { flush(i); blocks.push(<p key={i} className="my-3 leading-relaxed text-plum-ink/90">{inline(line)}</p>); }
  });
  flush("end");
  return <div className={className}>{blocks}</div>;
}
